import { render, staticRenderFns } from "./showProject.vue?vue&type=template&id=fbac0c8e&scoped=true&"
import script from "./showProject.vue?vue&type=script&lang=js&"
export * from "./showProject.vue?vue&type=script&lang=js&"
import style0 from "./showProject.vue?vue&type=style&index=0&id=fbac0c8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbac0c8e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PreApplicationQuestions: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/app/project/preApplicationQuestions.vue').default,ReferralModal: require('/opt/atlassian/pipelines/agent/build/frontend/apps/freelancer/components/app/project/ReferralModal.vue').default})
